import { FC, MutableRefObject, memo } from 'react';
// 组件
import FormModal from '../../../FormModal';
// 常量
import { FormModalActionType } from '../../../FormModal/interface';
import { useGetFormItems } from './formModalConfig';

interface DraftsFormModalProps {
  actionRef: MutableRefObject<FormModalActionType>;
  draftsData?: boolean;
  onOk?: (values: any) => void;
}

const DraftsFormModal: FC<DraftsFormModalProps> = memo(props => {
  const { actionRef, draftsData, onOk } = props;
  const handleSubmit = (values: any) => {
    actionRef.current?.hide();
    onOk?.(values);
  };
  const formItems = useGetFormItems(actionRef, draftsData);
  return (
    <FormModal
      title="保存草稿箱"
      actionRef={actionRef}
      formItems={formItems}
      destroyOnClose={true}
      onSubmit={handleSubmit}
      defaultLineNumber={1}
      defaultLabelCol={{ span: 8 }}
      size={500}
    />
  );
});

export default DraftsFormModal;
